import {
  APP_NS,
  LEGACY_STORAGE_KEYS,
  STORAGE_KEYS,
} from '@/constants/appIdentity'

/**
 * 将遗留旧键迁移到本项目命名空间，并删除旧键，避免同域其它项目读到。
 * 本文件在被 import 时立即执行一次（须早于 vuex-persistedstate 读盘）。
 */
export function migrateLegacyStorage() {
  try {
    if (typeof localStorage === 'undefined') return

    const pairs = [
      [LEGACY_STORAGE_KEYS[0], STORAGE_KEYS.token],
      [LEGACY_STORAGE_KEYS[1], STORAGE_KEYS.userInfo],
      [LEGACY_STORAGE_KEYS[2], STORAGE_KEYS.vuex],
      [LEGACY_STORAGE_KEYS[3], STORAGE_KEYS.webConfig],
      [LEGACY_STORAGE_KEYS[4], STORAGE_KEYS.webConfigV2],
      [LEGACY_STORAGE_KEYS[5], STORAGE_KEYS.supportToken],
    ]

    pairs.forEach(([legacyKey, nextKey]) => {
      if (!legacyKey || !nextKey) return
      const legacyVal = localStorage.getItem(legacyKey)
      const nextVal = localStorage.getItem(nextKey)
      if (legacyVal != null && nextVal == null) {
        localStorage.setItem(nextKey, legacyVal)
      }
      if (legacyVal != null) {
        localStorage.removeItem(legacyKey)
      }
    })

    // 清理遗留共用 API 缓存前缀，以及旧 gate_cb
    try {
      const keys = []
      for (let i = 0; i < sessionStorage.length; i += 1) {
        const key = sessionStorage.key(i)
        if (
          key &&
          (key.startsWith('ysm:api-cache:') || key === 'gate_cb')
        ) {
          keys.push(key)
        }
      }
      keys.forEach((key) => sessionStorage.removeItem(key))
    } catch (e) {
      // ignore
    }

    localStorage.setItem(`${APP_NS}:storage-ns`, '1')
  } catch (e) {
    // ignore
  }
}

migrateLegacyStorage()
